import React, { useEffect, useState } from 'react'
import Nav from '../Component/Nav'
import BottomNav from '../Component/BottomNav'
import SwiperSkills from '../Component/SwiperSkills'
import { Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import AOS from 'aos';
import 'aos/dist/aos.css';
import './aoss.css';
import { useTypewriter, Cursor } from 'react-simple-typewriter'
import Grid from '@mui/material/Grid2';
// Icons
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

AOS.init({
    duration: 1000,
    once: false,
    mirror: true,
})

export default function Home() {
    let [work] = useTypewriter({
        words: ['Front End Developer', 'React Developer', 'Freelancer'],
        loop: {},
    })

    let [showBtnToUp, setShowBtnToUp] = useState(false);

    const [open, setOpen] = useState(false);
    const [ProjectDesc, SetProjectDesc] = useState({
        title: '',
        id: '',
        desc: [],
        link: '',
    });
    const handleClickOpen = (work) => {
        setOpen(true);
        SetProjectDesc({ title: work.title, id: work.id, desc: work.desc, link: work.link })
    };
    const handleClose = () => {
        setOpen(false);
    };

    function handleScroll() {
        let scroll = window.scrollY;
        if (scroll > 150) {
            setShowBtnToUp(true);
        } else {
            setShowBtnToUp(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    let portfolioWorks = [
        {
            img: require('../image/Projects/Ecommerce.png'),
            title: 'Ecommerce',
            desc: ['An online store project', 'you can create an account', 'log in', 'choose products', 'browse products and purchase', 'the site is for display only'],
            link: 'https://mohamedahmed26.github.io/Ecommerce/',
            id: 1,
        },
        {
            img: require('../image/Projects/Dashboard.png'),
            title: 'Dashboard',
            desc: ['Dashboard project: Control your site', 'manage pages', 'control courses', 'control personal pages', 'settings', 'control friends', 'control files', 'monthly or annual subscription', 'the site is for display only'],
            link: 'https://mohamedahmed26.github.io/Dashboard/',
            id: 2,
        },
        {
            img: require('../image/Projects/SocialMedia.png'),
            title: 'Social Media',
            desc: ['Social media project', 'create a new account', 'log in', 'add posts', 'add a comment', 'personal page', 'visit others', 'add comments'],
            link: 'https://mohamedahmed26.github.io/Social-Media/',
            id: 3,
        },
        {
            img: require('../image/Projects/portfolioThree.png'),
            title: 'Portfolio',
            desc: ['Portfolio project', 'articles about me', 'my projects', 'my skills', 'contact me'],
            link: 'https://mohamedahmed26.github.io/Portfolio-three/',
            id: 4,
        },
        {
            img: require('../image/Projects/Calculator.png'),
            title: 'Calculator',
            desc: ['A calculator that performs addition, multiplication, division and subtraction'],
            link: 'https://mohamedahmed26.github.io/calculator/',
            id: 5,
        },
        {
            img: require('../image/Projects/DigitalAgence.png'),
            title: 'Digital Agency',
            desc: ['Marketing company project', 'information about the company', 'clients', 'company services', 'contact us'],
            link: 'https://mohamedahmed26.github.io/Digital-Agence/',
            id: 6,
        },
        {
            img: require('../image/Projects/LogIn.png'),
            title: 'Log In',
            desc: ['Project login with conditions'],
            link: 'https://mohamedahmed26.github.io/Log-In/',
            id: 7,
        },
        {
            img: require('../image/Projects/TicTac.png'),
            title: 'Tic Tac',
            desc: ['XO game And', 'show the winner'],
            link: 'https://mohamedahmed26.github.io/Tic-Tac-game/',
            id: 8,
        },
        {
            img: require('../image/Projects/ToDoList.png'),
            title: 'ToDo List',
            desc: ['Task management project', 'adding tasks', 'deleting tasks', 'adding an important task', 'completing the task.'],
            link: 'https://mohamedahmed26.github.io/To-do-list/',
            id: 9,
        },
        {
            img: require('../image/Projects/TodoListReact.png'),
            title: 'ToDo List React',
            desc: ['Task management project', 'adding tasks', 'deleting tasks', 'adding an important task', 'completing the task.', 'separating completed tasks from unfinished ones.'],
            link: 'https://todoo-list-react.netlify.app/',
            id: 10,
        },
        {
            img: require('../image/Projects/WeatherApp.png'),
            title: 'Weather App',
            desc: ['Knowing the weather', 'knowing the weather', 'maximum temperature', 'minimum temperature'],
            link: 'https://weather-react-app-elhot.netlify.app/',
            id: 11,
        },
        {
            img: require('../image/Projects/AladanTimeReact.png'),
            title: 'Aladan Time React',
            desc: ['The call to prayer project', 'knowing the time of the next call to prayer', 'the current time', 'knowing the call to prayer according to each city'],
            link: 'https://aladan-times.netlify.app/',
            id: 12,
        },
        {
            img: require('../image/Projects/YourAge.png'),
            title: 'YourAge',
            desc: ['Enter your date of birth and it will show you how old you are in years months and days'],
            link: 'https://mohamedahmed26.github.io/YourAge/',
            id: 13,
        },
        {
            img: require('../image/Projects/MarketingReact.png'),
            title: 'Marketing',
            desc: [`A project that presents a marketing company, its divisions, articles about marketing, the basics of social media, and customers’ opinions about us`],
            link: 'https://marketing-agency-elhot.netlify.app/',
            id: 14,
        },
        {
            img: require('../image/Projects/OceanDashboard.png'),
            title: 'Ocean Dashboard',
            desc: [`Ocean is a minimalistic, one-page admin dashboard template built with Next.js. It features a clean and lightweight design, making it ideal as a starting point for any dashboard project or a main page for displaying key information. The template is fully responsive and runs smoothly on all devices.`],
            link: 'https://ocean-elhot.netlify.app/',
            id: 15,
        },
        {
            img: require('../image/Projects/Dashboard Ali.png'),
            title: 'Admin Dashboard',
            desc: [`A modern and interactive admin dashboard built with React, designed for managing data and displaying analytics efficiently. It features a sleek UI with light and dark modes, dynamic sidebars, data tables, and interactive charts. This fully responsive dashboard serves as a ready-to-use template for various management systems and can be easily customized to meet different needs.`],
            link: 'https://dashboard-admin-elhot.netlify.app/',
            id: 16,
        },
    ];

    return (
        <>
            {/* Start Nav */}
            <Nav />
            {/* End Nav */}

            {/* Start Header */}
            <div
                className='Header'
                id='Home'
                style={{
                    background: '#0f0715',
                    position: 'relative',
                    zIndex: '1',
                    marginTop: '100px',
                }}>
                <Container maxWidth="lg" className='Container-mui'
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        position: 'relative',
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        background: '#0f0715',
                        zIndex: '-1',
                        '@media (max-width: 425px)': {
                            flexDirection: 'column-reverse',
                        },
                    }}>

                    <div className='me' style={{ width: '58%' }}>
                        <p style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: "white",
                            fontWeight: "600",
                            fontSize: "40px",
                        }} data-aos="fade-down">Hello
                            <img loading='lazy'
                                alt='Hello'
                                src={require('../image/hello.png')}
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    marginLeft: '10px'
                                }}
                            />
                        </p>

                        <h1 className='myName' style={{
                            color: 'white',
                            fontSize: '42px',
                            fontWeight: '900',
                            lineHeight: '1.5',
                        }} data-aos="fade-down">
                            I am <span
                                style={{
                                    background: 'linear-gradient(163deg, #b300ff, #ffffff)',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                Mohamed Ahmed
                            </span>
                        </h1>

                        <h1 className='work' style={{
                            lineHeight: '1.5',
                            fontSize: '35px',
                            fontWeight: '600',
                        }} data-aos="fade-down">
                            <span style={{
                                background: 'linear-gradient(152deg, rgb(179, 0, 255), rgb(255, 255, 255)) text',
                                WebkitTextFillColor: 'transparent',
                                width: 'max-content',
                            }}>
                                {work}
                            </span>

                            <span style={{ color: '#b300ff' }}>
                                <Cursor />
                            </span>
                        </h1>

                        <p className='descWork' style={{
                            fontWeight: '600',
                            color: 'white',
                            lineHeight: '1.6',
                            wordSpacing: '2px',
                            fontSize: '17px',
                            margin: '20px 0',
                        }} data-aos="fade-up">
                            Professional front-end programmer, dedicated to creating seamless and engaging user experiences.
                            I blend creative design with modern programming techniques,
                            ensuring exceptional performance and an integrated user interface,
                            while adhering to industry best practices
                        </p>
                        <div className='links' style={{
                            marginBottom: "20px",
                            display: "flex",
                            alignItems: "center",
                        }} data-aos="fade-up">
                            <a className="btn" download="Mohamed Ahmed Front end Cv.pdf" href="/Cv.pdf">
                                Resume
                            </a>

                            <button className="btn" onClick={() => {
                                window.open('https://github.com/MohamedAhmed26', '_blank')
                            }}
                            ><GitHubIcon /></button>
                            <button className="btn" onClick={() => {
                                window.open('https://www.linkedin.com/in/mohamed-elhot', '_blank')
                            }}
                            ><LinkedInIcon /></button>
                            <button className="btn" onClick={() => {
                                window.open('https://www.facebook.com/profile.php?id=61559140927705', '_blank')
                            }}
                            ><FacebookIcon /></button>
                        </div>
                    </div>

                    <div className='pic' style={{
                        width: '38%',
                    }} data-aos="fade-left">
                        <img loading='lazy' className='me' src={require('../image/me.jpg')} alt='Me' />
                    </div>
                </Container>
            </div>
            {/* End Header */}

            {/* Start About */}
            <div
                className='about'
                id='About'
                style={{
                    background: 'linear-gradient(to left, #190822, #1e1830)',
                    padding: '40px 0',
                }}>
                <Container>
                    <h1 className='aboutTitle' style={{
                        background: 'linear-gradient(170deg, #b300ff, #ffffff)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        width: 'max-content',
                        fontSize: "40px",
                        fontWeight: "800",
                        margin: '0 auto 15px',
                    }}>About me</h1>
                    <div className='aboutInfoParent' style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <div className='aboutInfoParent' style={{
                            width: '60%'
                        }}>
                            <h3 style={{
                                color: 'white',
                                fontSize: '17px',
                                fontWeight: '600',
                                lineHeight: '1.7',
                            }} data-aos="fade-down">
                                Hello, I'm Mohamed Ahmed, a web developer specializing in front-end development.
                                I have strong experience in React and CSS,
                                and I have started my journey in learning Next js.
                                My passion for technology drives me to continuously explore and enhance
                                my skills in order to create exceptional web experiences.
                            </h3>

                            {/* Start Links btn */}
                            <ul className="example-2" data-aos="fade-up">
                                <li className="icon-content">
                                    <a
                                        href="https://www.linkedin.com/in/mohamed-elhot"
                                        target='_blank'
                                        aria-label="LinkedIn"
                                        data-social="linkedin"
                                    >
                                        <div className="filled"></div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-linkedin"
                                            viewBox="0 0 16 16"
                                            space="preserve"
                                        >
                                            <path
                                                d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"
                                                fill="currentColor"
                                            ></path>
                                        </svg>
                                    </a>
                                    <div className="tooltip">LinkedIn</div>
                                </li>
                                <li className="icon-content">
                                    <a
                                        href="https://github.com/MohamedAhmed26"
                                        target='_blank'
                                        aria-label="GitHub" data-social="github">
                                        <div className="filled"></div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-github"
                                            viewBox="0 0 16 16"
                                            space="preserve"
                                        >
                                            <path
                                                d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8"
                                                fill="currentColor"
                                            ></path>
                                        </svg>
                                    </a>
                                    <div className="tooltip">GitHub</div>
                                </li>
                                <li className="icon-content">
                                    <a
                                        href="https://www.instagram.com/e5c.u/"
                                        target='_blank'
                                        aria-label="Instagram"
                                        data-social="instagram"
                                    >
                                        <div className="filled"></div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-instagram"
                                            viewBox="0 0 16 16"
                                            space="preserve"
                                        >
                                            <path
                                                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"
                                                fill="currentColor"
                                            ></path>
                                        </svg>
                                    </a>
                                    <div className="tooltip">Instagram</div>
                                </li>
                                <li className="icon-content">
                                    <a
                                        href="https://www.facebook.com/profile.php?id=61559140927705"
                                        target='_blank'
                                        aria-label="facebook"
                                        data-social="facebook">
                                        <div className="filled"></div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-facebook"
                                            viewBox="0 0 24 24"
                                            space="preserve"
                                        >
                                            <path
                                                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                                            ></path>
                                        </svg>
                                    </a>
                                    <div className="tooltip">Facebook</div>
                                </li>
                            </ul>
                            {/* End Links btn */}

                        </div>
                        <div className='aboutImgParent' style={{
                            width: '40%',
                            textAlign: 'center',
                        }} data-aos="fade-left">
                            <img loading='lazy'
                                src={require('../image/animation.png')} alt='Logo Animation' style={{
                                    width: '90%',
                                    height: '90%',
                                }}
                            />
                        </div>
                    </div>
                </Container>
            </div>
            {/* End About */}

            {/* Start Skills */}
            <div className='Skills' id='Skills' style={{
                background: '#0f0715',
                overflow: 'hidden',
                padding: '40px 0px',
                zIndex: '1',
                position: 'relative',
            }}>
                <Container className='Container-mui' style={{
                    zIndex: '-2',
                }}>
                    <h1 className='skillsTitle' style={{
                        background: 'linear-gradient(170deg, #b300ff, #ffffff)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        width: 'max-content',
                        fontSize: "40px",
                        fontWeight: "800",
                        margin: '0 auto 15px',
                    }}>My Skills</h1>
                    <SwiperSkills />
                </Container>
            </div>
            {/* End Skills */}
            {/* Start btn to up */}
            <div className='btnToUp' style={{
                display: showBtnToUp ? 'flex' : 'none',
                position: 'fixed',
                bottom: '3%',
                right: '3%',
                background: '#ad09ff',
                width: '50px',
                height: '50px',
                // display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid #4f0c84',
                borderRadius: '50%',
                cursor: 'pointer',
                zIndex: '100',
            }} onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' })
            }}>
                <ArrowUpwardIcon style={{
                    width: '45px !important',
                    height: '30px',
                    color: '#200732',
                }} />
            </div>
            {/* End btn to up */}
            {/* Start Portfolio */}
            <div className='portfolio' id='Portfolio' style={{
                background: 'linear-gradient(to left, #190822, #1e1830)',
                padding: '40px 0px',
            }}>
                <Container>
                    <h1 className='aboutTitle' style={{
                        background: 'linear-gradient(170deg, #b300ff, #ffffff)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        width: 'max-content',
                        fontSize: "40px",
                        fontWeight: "800",
                        margin: '0 auto 40px',
                    }}>Portfolio</h1>

                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{
                        placeContent: 'center',
                    }}>
                        {
                            portfolioWorks.map(work => (
                                <Grid className='workPortfolio' data-aos="zoom-in" item key={work.id}
                                    sx={{
                                        width: 'calc(95% / 3)',
                                        '@media (max-width: 425px)': {
                                            width: '97% !important',
                                        },
                                        '@media (max-width: 768px)': {
                                            width: 'calc(95% / 2)',
                                        },
                                        borderRadius: '15px',
                                        border: '1px solid #a400f9c9',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        cursor: 'pointer',
                                    }}>
                                    <img loading='lazy' src={work.img} alt={work.title} style={{
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '15px',
                                        objectFit: 'cover',
                                    }} />

                                    <div className='hoverWork'>
                                        <h1 style={{
                                            fontSize: '40px',
                                            fontWeight: '600',
                                            color: '#ffffff',
                                            marginBottom: '15px',
                                        }}>{work.title}</h1>
                                        <button className='btnHoverPortfolio' style={{
                                            padding: '10px 25px',
                                            borderRadius: '15px',
                                            background: '#c400ff',
                                            color: '#ffffff',
                                        }}
                                            onClick={() => {
                                                handleClickOpen(work)
                                            }}>Details</button>
                                    </div>

                                </Grid>
                            ))
                        }
                    </Grid>
                    <a className="btn" href="https://github.com/MohamedAhmed26" target='_blank' style={{
                        margin: '25px auto 0',
                        borderRadius: '15px',
                        width: '126px',
                    }}>
                        Github
                    </a>
                </Container>
            </div>

            {/* Start DescProject */}
            <Dialog
                data-aos="zoom-in"
                data-aos-duration="500"
                open={open}
                onClose={handleClose}
                component={"div"}>
                <DialogTitle sx={{
                    fontSize: '28px',
                    fontWeight: '600',
                }}>{ProjectDesc.title}</DialogTitle>
                <DialogContent>
                    <ol style={{ padding: '15px', }}>
                        {
                            ProjectDesc.desc.map((project, index) => (
                                <li key={index} style={{ fontSize: '20px' }}>{project}</li>
                            ))
                        }
                    </ol>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        window.open(ProjectDesc.link, '_blank');
                    }}>Link</Button>
                    <Button onClick={handleClose}>Ok</Button>
                </DialogActions>
            </Dialog>
            {/* End DescProject */}
            {/* End Portfolio */}

            {/* Start Footer */}
            <div className='footer' style={{
                background: '#0f0715',
                position: 'relative',
                padding: '20px 0'
            }}>
                <Container>
                    <p style={{
                        color: 'white',
                        fontSize: '20px',
                        marginBottom: '3px',
                        textAlign: 'center',
                    }}>Mohamed Ahmed</p>
                    <span style={{
                        fontSize: '18px',
                        color: 'white',
                        textAlign: 'center',
                        display: 'block',
                    }}>©{new Date().getFullYear()} All Rights Reserved by Mohamed Ahmed</span>
                </Container>
            </div>
            {/* End Footer */}
            {/* Start BottomNav */}
            <BottomNav />
            {/* End BottomNav */}
        </>
    )
}